/**
 * Stat Group count-up. Loaded from sections/stat-group.liquid as type="module".
 */

const SELECTOR = '[data-section-type="stat-group"]'
const VIEW_RATIO = 0.7

function prefersReducedMotion() {
  return matchMedia('(prefers-reduced-motion: reduce)').matches
}

function decimalPlaces(n) {
  const text = String(n)
  return text.includes('.') ? text.split('.')[1].length : 0
}

function formatValue(value, decimals, useLocale) {
  if (useLocale) {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    })
  }

  return decimals ? value.toFixed(decimals) : String(Math.round(value))
}

function setText(el, value, decimals, useLocale) {
  el.textContent = formatValue(value, decimals, useLocale) + (el.dataset.unit || '')
}

function easeInOut(t) {
  return t < 0.5 ? 2 * t * t : 1 - (-2 * t + 2) ** 2 / 2
}

function animate(el, target, duration, useLocale) {
  const decimals = decimalPlaces(target)

  if (prefersReducedMotion() || duration <= 0) {
    setText(el, target, decimals, useLocale)
    return
  }

  const start = performance.now()

  function tick(now) {
    const t = Math.min((now - start) / duration, 1)
    setText(el, target * easeInOut(t), decimals, useLocale)
    if (t < 1) requestAnimationFrame(tick)
  }

  requestAnimationFrame(tick)
}

function init(container) {
  if (container.dataset.statInit) return
  container.dataset.statInit = 'true'

  const duration = Number(container.dataset.duration) || 1500
  const useLocale = container.dataset.pdpFormat !== 'true'
  const numbers = [...container.querySelectorAll('[data-stat-number]')]

  for (const el of numbers) {
    setText(el, 0, decimalPlaces(Number(el.dataset.number) || 0), useLocale)
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry?.isIntersecting || entry.intersectionRatio < VIEW_RATIO) return
      observer.disconnect()
      for (const el of numbers) {
        animate(el, Number(el.dataset.number) || 0, duration, useLocale)
      }
    },
    { threshold: VIEW_RATIO }
  )

  observer.observe(container)
}

function initAll(root = document) {
  root.querySelectorAll(SELECTOR).forEach(init)
}

initAll()

document.addEventListener('shopify:section:load', (event) => {
  initAll(event.target)
})
